import React, { useState } from "react";
import DivButton from "./Generic/DivButton";
import UtilityInput from "./Generic/UtilityInput";
// import FNum from "../Utils/FormatNumber";
import "./Inflation.css";
export default function InflationCalculator(props) {
  const [inputs, setInputs] = useState({});
  const [totals, setTotals] = useState([]);

  function handleValue(event) {
    const name = event.target.id;
    const value = parseFloat(event.target.value.replaceAll(",", ""));
    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
  }

  function handleChange(event) {
    const name = event.target.id;
    let value = event.target.value.replaceAll(",", "");
    if (name.includes("Rate") === false) value = parseFloat(value);
    if (isNaN(value) === true) value = "";

    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
    // console.log(`inputs[${name}] :>> `, inputs[name]);
  }

  function handleSubmit(event) {
    event.preventDefault();
    let total = 0;
    const ia = [
      //inputs Array
      inputs["Years"],
      inputs["Inflation_Rate"],
      inputs["Original_Amount"],
    ];

    for (let i = 0; i < ia.length; i++) {
      const e = ia[i];
      if (e === undefined || e === 0 || isNaN(e) === true || e === "") {
        // console.log("error");
        return;
      }
      //console.log(e, "e");
    }

    const years = parseInt(inputs.Years);
    const originalAmount = parseFloat(inputs.Original_Amount);
    const inflationRate = parseFloat(inputs.Inflation_Rate);
    total = originalAmount;
    for (let y = 0; y < years; y++) {
      total += total * (inflationRate / 100);
    }
    //console.log("total", total);
    addTotal(total);
  }

  function addTotal(newTotal) {
    const updateTotals = [
      ...totals,
      {
        id: totals.length + 1,
        years: inputs.Years,
        inflation_Rate: inputs.Inflation_Rate + "%",
        original_Amount: "$" + inputs.Original_Amount.toLocaleString(),
        total:
          "$" +
          parseFloat(newTotal).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
      },
    ];
    setTotals(updateTotals);
  }
  function clearVal(id) {
    setInputs((values) => ({
      ...values,
      [id]: "",
    }));
  }

  function clearTotal(indx) {
    const updateTotals = [...totals];
    updateTotals.splice(indx, 1);
    setTotals(updateTotals);
  }

  function clearThis(indx) {
    clearTotal(indx);
    //console.log("Total Index", indx);
  }
  function clearAll() {
    setTotals([]);
  }

  function clearAllInputs() {
    setInputs({});
  }

  if (props.Subscribed === false) {
    return (
      <div className="OverviewContainer">
        This feature is only available for subscribers
      </div>
    );
  }

  return (
    <>
      <br />
      <div className="OverviewContainer hoverBox inflation">
        <h2>Inflation Calculator</h2>
        <p>
          This calculator shows the rate of increase in prices over a given
          period of time.
        </p>
        <div className="inputs">
          <UtilityInput
            id="Years"
            handleValue={handleValue}
            guidelines=" How many years into the future you are projecting."
            clear={() => clearVal("Years")}
            value={inputs["Years"]}
            handleChange={(event) => {
              handleChange(event);
            }}
          ></UtilityInput>
          <UtilityInput
            id="Inflation_Rate"
            displayLabel="Inflation Rate"
            guidelines=" Percentage price increase each year. "
            isPercent={true}
            handleValue={handleValue}
            clear={() => clearVal("Inflation_Rate")}
            value={inputs["Inflation_Rate"]}
            handleChange={(event) => {
              handleChange(event);
            }}
          ></UtilityInput>
          <UtilityInput
            id="Original_Amount"
            displayLabel="Original Amount"
            guidelines="Amount in today’s dollar."
            handleValue={handleValue}
            canLoad={false}
            clear={() => clearVal("Original_Amount")}
            value={inputs["Original_Amount"]}
            handleChange={(event) => {
              handleChange(event);
            }}
          ></UtilityInput>
        </div>
        <DivButton classList={"small"} onClick={clearAllInputs}>
          Clear Inputs
        </DivButton>
        <DivButton classList={"small"} onClick={(event) => handleSubmit(event)}>
          <h4>Calculate</h4>
        </DivButton>
        <div className="results">
          {totals.length === 0
            ? ""
            : totals.map((id) => {
                const item = id;
                return (
                  <>
                    <div
                      className="inflationTotal"
                      key={totals.indexOf(id)}
                      onClick={() => clearThis(totals.indexOf(id))}
                    >
                      {Object.keys(item).map((property) => {
                        if (property === "id") {
                          return (
                            <div className="lineItem" key={property}>
                              Calculation #{totals.indexOf(id) + 1}
                            </div>
                          );
                        }
                        return (
                          <div className="lineItem" key={property}>
                            <div>{` ${property.replaceAll("_", " ")}: `} </div>{" "}
                            <div>{`${item[property]}`}</div>
                          </div>
                        );
                      })}
                      Click to Clear
                    </div>
                  </>
                );
              })}
        </div>
        {totals.length === 0 ? (
          ""
        ) : (
          <DivButton onClick={clearAll} classList="small">
            Clear Simulations
          </DivButton>
        )}
      </div>
    </>
  );
}
